import { httpClient, getApplicationHeaders } from "@utils";

class PlatformAuthAvailabilityApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/agency-users`;
	}

	static getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static checkUserNameAvailability(body: string): Promise<boolean> {
		return httpClient.post(
			`${this.baseUrl}/userName-availability`,
			JSON.stringify(body),
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}

	static checkEmailAvailability(body: string): Promise<boolean> {
		return httpClient.post(
			`${this.baseUrl}/email-availability`,
			JSON.stringify(body),
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}
}

export default PlatformAuthAvailabilityApiService;
